import React, { useState, useEffect, useContext } from 'react';
import TitleBar from '../components/TitleBar.jsx';
import '../styles/prompt_library.css';
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip, } from 'react-tooltip';
import { urlValue } from '../lib'
import { projectContext, loadingContext, unfolder, openAlert, useTranslate } from '../lib'
import axios from 'axios';
import { Alerts } from '../components/common/Alerts'

const PromptLibrary = ()=>{
    const [loading, setLoading] = useContext(loadingContext);
    const [promptData, setPromptData] = useState({
        role: '',
        task: '',
        context: ''
    });
    const [alert, setAlert] = useState({ title: '', visible: false })
    const { t } = useTranslate();
    // Función para obtener los datos del prompt
    const getPromptDefault = async () => {
        try {
            const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
            const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;

            const response = await axios({
                method: 'get',
                url: `${urlValue}/studio/prompt/library/default`,
                headers: {
                    user: id,
                    'access-token': token,
                }
            });

            if (response.data) {
                setPromptData(response.data);
                // También actualizamos los valores de los textareas
                document.getElementById('role').value = response.data.role || '';
                document.getElementById('task').value = response.data.task || '';
                document.getElementById('context').value = response.data.context || '';
                document.getElementById('rules').value = response.data.rules || '';
                document.getElementById('forbidden_actions').value = response.data.forbidden_actions || '';
                document.getElementById('default_fallback').value = response.data.default_fallback || '';
                document.getElementById('example').value = response.data.example || '';
                document.getElementById('other').value = response.data.other || '';
            }
        } catch (error) {
            console.error('Error al obtener el prompt default:', error);
        }
    };

    // Cargar datos cuando el componente se monta
    useEffect(() => {
        getPromptDefault();
    }, []);

    const savePromptDefault = async (e)=>{
        //e.preventDefault();

        //setLoading(true);

        const rolContent = document.getElementById('role').value;
        const taskContent = document.getElementById('task').value; 
        const contextContent = document.getElementById('context').value; 
        const rulesContent = document.getElementById('rules').value;
        const forbiddenActionsContent = document.getElementById('forbidden_actions').value;
        const defaultFallbackContent = document.getElementById('default_fallback').value;
        const exampleContent = document.getElementById('example').value;
        const otherContent = document.getElementById('other').value;

        const data = {
            role: rolContent,
            task: taskContent,
            context: contextContent,
            rules: rulesContent,
            forbidden_actions: forbiddenActionsContent,
            default_fallback: defaultFallbackContent,
            example: exampleContent,
            other: otherContent,
        } 
        console.log('data', data)
        const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        const csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

        axios({
            method: 'post',
            url: `${urlValue}/studio/prompt/library/save`,
            headers: {
                user: id,
                'access-token': token,
                'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
            data: data,
        }).then(function (res) {
            setLoading(false);
            setPromptData(data);
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.promptTemplateSave'), visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        }).catch(error => {
            console.log('Error to try update bot sentiment: ', error);
        })
    }

    return <div className='general-container'>
        <TitleBar />
        <div className='primary-container d-flex flex-row flex-wrap justify-content-between mt-3'>
            <h1>{t('menu.genai.promptLibrary')}</h1>
            <div className="box-tool">
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                    <h2>{t('menu.genai.defaultPromptData')}:</h2>
                    <div className='tooltip-div' style={{ marginRight: 12 }}>
                        <img id="campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                        <button onClick={savePromptDefault}
                            className='button-setup camp-btn' type="button" style={{ borderRadius: 5, backgroundColor: '#0038A8' }}
                        >
                            {t('common.save')}
                        </button>
                        <Tooltip events={['click']} anchorId="campaing-tp" st={undefined}
                            content={t('menu.genai.promptTemplateTooltip')} place="top" />
                    </div>
                </div>
                <form id="prompt-default-form" className='d-flex flex-wrap' >
                    <div className='items-little'>
                        <div className='input-container'>
                            <label htmlFor="role">{t('menu.genai.role')}:</label>
                            <textarea name="role" id="role" rows="4" />
                        </div>
                        <div className='input-container'>
                            <label htmlFor="task">{t('menu.genai.task')}:</label>
                            <textarea name="task" id="task" rows="4" />
                        </div>
                    </div>
                    <div className='item-context'>
                        <div className='input-container' style={{width: '100%'}}>
                            <label htmlFor="context">{t('menu.genai.context')}:</label>
                            <textarea name="context" id="context" rows="11" />
                        </div>
                    </div>
                    <div id='secondary_container' class="w-100 d-flex flex-row flex-wrap">
                        <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="rules">{t('menu.genai.rules')}:</label>
                                <textarea name="rules" id="rules" rows="6" />
                            </div>
                        </div>
                        <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="forbidden_actions">{t('menu.genai.forbiddenActions')}</label>
                                <textarea name="forbidden_actions" id="forbidden_actions" rows="6" />
                            </div>
                        </div>
                        <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="default_fallback">{t('menu.genai.defaultFallback')}:</label>
                                <textarea name="default_fallback" id="default_fallback" rows="6" />
                            </div>
                        </div>
                        <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="example">{t('menu.genai.example')}:</label>
                                <textarea name="example" id="example" rows="6" />
                            </div>
                        </div>
                        <div className='items-little'>
                            <div className='input-container' style={{width: '100%'}}>
                                <label htmlFor="other">{t('common.other')}:</label>
                                <textarea name="other" id="other" rows="6" />
                            </div>
                        </div>
                    </div>
                    
                    <div style={{display: 'flex', flexDirection: 'row-reverse', flexWrap: 'wrap', width: '100%'}}>
                        <div className='tooltip-div' style={{ marginRight: 12 }}>
                            <img id="campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                            <button onClick={savePromptDefault}
                                className='button-setup camp-btn' type="button" style={{ borderRadius: 5, backgroundColor: '#0038A8' }}
                            >
                                {t('common.save')}
                            </button>
                            <Tooltip events={['click']} anchorId="campaing-tp" st={undefined}
                                content={t('menu.genai.promptTemplateTooltip')} place="top" />
                        </div>
                    </div>

                </form>
            </div>
            
        </div>
        {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
    </div>
}

export default PromptLibrary;